{
  "en": {
    "locale_field": {
      "fallback_tooltip": "When no text is entered for this language, this default text will be used as the fallback.",
      "fill_missing": "Fill missing language ({count}) | Fill missing languages ({count})",
      "fill_missing_budget_used": "This month's AI budget is used.",
      "fill_missing_done": "Missing languages filled in. Check the text before you save.",
      "fill_missing_errors": {
        "budget_reached": "This month's AI budget has been used. Contact Ziggu to raise it.",
        "generic": "The languages could not be filled in. Please try again.",
        "too_long": "This text is too long to translate in one go."
      },
      "fill_missing_tooltip": "Translates from {language} with AI. Check the text before you save.",
      "translated_in": "Translated in"
    }
  }
}
